import { Group, IconProps } from 'grommet-icons';

export const UsersIcon: React.FC<IconProps> = (props) => <Group size="24px" color="brand" {...props} />;
